/** Pasos en los que firmar el contrato cierra el paso: 2.3 del tronco y su espejo 2.4.5. */
export const ContractSignatureAdvanceStepKeys = ["2.3", "2.4.5"];

/**
 * Sección 4: el plan ya está contratado y sólo re-firma una versión nueva del contrato (aviso de
 * contrato caducado de la cabecera). Aquí no hay paso que avanzar.
 */
export const ContractRenewalStepKeys = ["4.1", "4.2", "4.3"];

/** Pasos vivos aceptados por las pantallas de firma del contrato. */
export const ContractSignatureStepKeys = [...ContractSignatureAdvanceStepKeys, ...ContractRenewalStepKeys];
